module.exports = __webpack_public_path__ + "img/pinterest.4ca3ca46.svg";